import * as React from 'react';

import Skeleton from '@/components/elements/Skeleton';
import { NewsType } from '@/pages/News/types';

import {
  Author,
  AuthorImage,
  AuthorName,
  Description,
  ProfileInfo,
} from '../Blog/style';
import { ContentHeader, PublishedAt, Title } from '../style';
import { BodyWrapper, ImageWrapper } from './style';

interface SkeletonContentBodyProps {
  newsType: NewsType;
}

const SkeletonContentBody: React.FC<SkeletonContentBodyProps> = ({
  newsType,
}) => {
  return (
    <>
      {newsType !== NewsType.News && (
        <ImageWrapper>
          <Skeleton
            width="100%"
            height="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </ImageWrapper>
      )}
      <ContentHeader>
        <PublishedAt>
          <Skeleton height="18px" width="100px" />
        </PublishedAt>
        <Title>
          <Skeleton height="24px" width="100%" count={2} />
        </Title>
      </ContentHeader>
      <BodyWrapper>
        <Skeleton height="20px" width="100%" count={20} />
      </BodyWrapper>
      {newsType === NewsType.Blog && (
        <Author>
          <ProfileInfo>
            <AuthorImage>
              <Skeleton />
            </AuthorImage>
            <div>
              <AuthorName to="/blog?author=">
                <Skeleton height="20px" width="100%" />
              </AuthorName>
            </div>
          </ProfileInfo>
          <Description>
            <Skeleton height="20px" width="100%" count={2} />
          </Description>
        </Author>
      )}
    </>
  );
};

export default SkeletonContentBody;
